import React, { useState, useEffect } from 'react';
import LoadFromLocalStorage from 'components/layout/options/LoadFromLocalStorage.jsx'
import { HandleActivationFormula, HandleOptionsUserChanged } from 'components/layout/options/drawing_options/index.js';

// Dropdown of admin-authored choices. The <select> value is a string token
// (option.select_choices[].value); the customer sees the localized description.
const Select = ({ item, option, value, onChange, enabled, doNotLoadFromLocalStorage }) => {
  const updateOptionsUserChanged = () => { HandleOptionsUserChanged().add(option.name) };
  const [active, setActive] = useState(true);
  const [weRecommend, setWeRecommend] = useState('');
  const choices = option.select_choices || [];

  useEffect(() => {
    if(enabled) {
      document.dispatchEvent(new CustomEvent('REDRAW_REQUESTED', { "detail": item.uuid }));
    }
  }, [value]);

  useEffect(() => {
    if(doNotLoadFromLocalStorage) { return; }
    LoadFromLocalStorage(item, option.name, onChange)
  }, []);

  const attachEvents = () => {
    if (option.has_activation_formula || option.has_value_formula) {
      HandleActivationFormula({
        option: option,
        item: item,
        setActive: setActive,
        setWeRecommend: setWeRecommend,
      });
    }
  }

  useEffect(attachEvents, [enabled, item]);

  if(!active) { return null; }

  return (
    <div className="LayoutRedrawFormInputRow">
      <div className="input-group short-text">
        <span className="input-group-addon">
          {option.description}
        </span>

        <select
          name={option.name}
          value={value}
          onChange={ e => onChange(e.target.value)}
          onClick={updateOptionsUserChanged}
          className="form-control-int form-control selectpickerl"
        >
          {choices.map((choice) => <option key={choice.value} value={choice.value}> {choice.description} </option>)}
        </select>
      </div>
    </div>
  )
}

export default Select
